import { defineStore } from 'pinia';
import { PreloadClass, IResourceItem } from '@/assets/ts/preload';
import { upgradeResourceList, magicWeaponResourceList } from './preload-resource';

import { useStore } from '.';
import { nextTick } from 'vue';
export const useStorePreload = defineStore('storePreload', {
    state: (): Record<string, any> => {
        return {
            /** svga文件 */
            svgaFiles: {},
            /** 预加载实例 */
            preloadIns: {
                progress: 0,
            },
            /** 预加载实例 - 根据接口判断的图片资源 */
            preloadInsApi: {
                progress: 0,
            },
        };
    },
    actions: {
        setPreloadIns(preloadIns: PreloadClass) {
            this.preloadIns = preloadIns;
        },
        setPreloadInsApi(preloadIns: PreloadClass) {
            this.preloadInsApi = preloadIns;
        },
        // 初始化预加载资源
        initPreloadResource(list: string[] = []) {
            const store = useStore();
            const resourceList: IResourceItem[] = [];
            let needPreloadList = [];
            if (list.length === 0) {
                const { spiritual_power_value, } = store.indexData;
                const { level_value, user_current_value, } = spiritual_power_value;
                // 是否能升级
                const canUpgrade = +user_current_value >= +level_value;
                if (canUpgrade) {
                    needPreloadList.push(...upgradeResourceList);
                }
            } else {
                needPreloadList = list;
            }
            if (needPreloadList.length === 0) {
                return;
            }
            for (const path of needPreloadList) {
                const _match = path.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
                console.log(path, _match);
                const _ext = _match![1];
                const _rgex = new RegExp(`([^/]+)\.${_ext}(?:\\?.*)?$`);
                const _match2 = path.match(_rgex);
                // 打包后会加上hash，xxx.[hash].svga
                const name = _match2![1].split('.')[0];
                resourceList.push({
                    type: 'svga',
                    name,
                    src: path,
                });
            }
            const preloadIns = new PreloadClass({ maxRetryCount: 3, resourceList, });
            preloadIns.initPreload();
            preloadIns.onCompleteItem = (info) => {
                if (info.type === 'svga') {
                    store.setSvgaFiles(info.name, info.data);
                }
            };
            this.setPreloadIns(preloadIns);
            return preloadIns;
        },
        // 通过接口返回的数据来预加载资源 - 图片资源
        async preloadResourceByApi(list: string[]) {
            const resourceList: IResourceItem[] = list.map((v) => ({
                type: 'img',
                name: v,
                src: v,
            }));
            const preloadInsApi = new PreloadClass({ maxRetryCount: 3, resourceList, });
            this.setPreloadInsApi(preloadInsApi);
            preloadInsApi.initPreload();
        },
    },
});
